var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isMobile } from '@/core/platform';
import { getApiAddress, getApiSkipAuth, getApiFullStyleEndpoint } from './apiConfig';
export class StyleNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = 'StyleNotFoundError';
    }
}
const FULL_STYLE_ENDPOINT = getApiFullStyleEndpoint();
const SCENE_QUALITY = isMobile() ? 'LOW' : 'MEDIUM';
function buildHeaders(apiKey) {
    return getApiSkipAuth() ? {} : { 'content-type': 'application/json', 'x-api-key': apiKey };
}
export function fetchStyleAggregatorData(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { apiKey, signal } = params;
        const search = new URLSearchParams({ quality: SCENE_QUALITY });
        if (params.mockupId) {
            search.set('mockup_id', params.mockupId);
        }
        else {
            const { brand, styleNumber, colorway } = params;
            if (!brand || !styleNumber) {
                throw new Error('Missing required parameters "brand" and/or "styleNumber" for style lookup.');
            }
            search.set('brand', brand);
            search.set('number', styleNumber);
            if (colorway)
                search.set('colorway', colorway);
        }
        const url = `${getApiAddress()}/${FULL_STYLE_ENDPOINT}?${search.toString()}`;
        const response = yield fetch(url, {
            headers: buildHeaders(apiKey),
            signal,
        });
        if (!response.ok) {
            if (response.status === 404) {
                if (params.mockupId) {
                    throw new StyleNotFoundError(`No styles found for Mockup ${params.mockupId}`);
                }
                const { brand, styleNumber, colorway } = params;
                throw new StyleNotFoundError(`No styles found for Brand ${brand}, Style Number ${styleNumber}, Colorway ${colorway !== null && colorway !== void 0 ? colorway : 'ANY'}`);
            }
            throw new Error(`Failed to fetch full style data: ${response.status}`);
        }
        return response.json();
    });
}
